<template lang="pug">
.error(v-if="!checkRestrictions(['ex:shop', 'ex:pos', 'ex:pos:points-of-sale'])")
    Error(:message="null" :code="403")
PaginatedItemsWrapper(
    v-else
    scope="ex"
    type="shop_pos"
    :items-paginated="itemsPaginated"
    router-path="pos-form"
    :loading="loading"
    :show-add-button="checkRestrictions(['ex:pos', 'ex:pos:points-of-sale'], 'update')"
    v-on:updateLoading="updateLoading"
    v-on:fetchItems="fetchItemsMethod"
    v-on:defineActiveColumns="defineActiveColumns"
    v-on:defineFilterVisibility="defineFilterVisibility"
    v-on:defineItemsPerPage="defineItemsPerPage"
    v-on:defineCurrentPage="defineCurrentPage"
    v-on:defineFilterValue="defineFilterValue"
    v-on:defineSort="defineSort"
)
</template>

<script>
import { checkRestrictions } from '@/helpers'
import { useSetupStore, useShopPosStore } from '@/stores'

import Error from '@/components/Error';
import PaginatedItemsWrapper from '@/components/PaginatedItemsWrapper';

export default {
    name: 'PointsOfSalesPaginated',
    components: {
        Error,
        PaginatedItemsWrapper,
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms;
        },
        posStore() {
            return useShopPosStore();
        },
        itemsPaginated() {
            return this.posStore.itemsPaginated;
        },
        loading() {
            return this.posStore.loading;
        },
    },
    methods: {
        fetchItemsMethod() {
            this.posStore.fetchPaginatedItems(this.activeCms.shop.id, this.activeCms.id)
                .then(() => this.posStore.updateLoading(false))
                .catch(err => { console.log(err) });
        },
        updateLoading(value) {
            this.posStore.updateLoading(value);
        },
        defineActiveColumns(columns) {
            this.posStore.defineActiveColumns(columns);
        },
        defineFilterVisibility(value) {
            this.posStore.defineFilterVisibility(value);
        },
        defineItemsPerPage(perPage) {
            this.posStore.defineItemsPerPage(perPage);
        },
        defineCurrentPage(page) {
            this.posStore.defineCurrentPage(page);
        },
        defineFilterValue(payload) {
            this.posStore.defineFilterValue(payload);
        },
        defineSort(payload) {
            this.posStore.defineSorting(payload);
        },
        checkRestrictions,
    }
};
</script>

<style lang="sass" scoped>
.error
    display: flex
    justify-content: center
    min-height: 200px
</style>
